
import { CheckCircle, Diamond } from "lucide-react";

const Benefits = () => {
  return (
    <section id="benefits" className="section relative overflow-hidden">
      {/* Diamond-inspired background elements */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-500/10 to-blue-300/5"></div>
        
        {/* Diamond-shaped elements */}
        <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-400/20 rotate-45 blur-2xl"></div>
        <div className="absolute bottom-1/3 right-1/4 w-64 h-64 bg-blue-300/20 rotate-45 blur-2xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-500/10 rotate-45 blur-2xl"></div>
        
        {/* Faceted pattern overlay */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI3NjUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIiB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI3NjUiLz48cGF0aCBkPSJNMCAwIEwxNDQwIDAgTDE0NDAgNzY1IEwwIDc2NSBMMCAwIFoiIHN0cm9rZT0iIzMzODJmNiIgc3Ryb2tlLXdpZHRoPSIuMjUiIHN0cm9rZS1vcGFjaXR5PSIuMSIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0wIDM4MiBMNzIwIDAgTDE0NDAgMzgyIEw3MjAgNzY1IEwwIDM4MiBaIiBzdHJva2U9IiMzMzgyZjYiIHN0cm9rZS13aWR0aD0iLjUiIHN0cm9rZS1vcGFjaXR5PSIuMiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0zNjAgMTkxIEw3MjAgMCBMMTA4MCAxOTEgTDcyMCAzODIgTDM2MCAxOTEgWiIgc3Ryb2tlPSIjMzM4MmY2IiBzdHJva2Utd2lkdGg9Ii41IiBzdHJva2Utb3BhY2l0eT0iLjMiIGZpbGw9Im5vbmUiLz48cGF0aCBkPSJNMzYwIDU3MyBMNzIwIDM4MiBMMTA4MCA1NzMgTDcyMCA3NjUgTDM2MCA1NzMgWiIgc3Ryb2tlPSIjMzM4MmY2IiBzdHJva2Utd2lkdGg9Ii41IiBzdHJva2Utb3BhY2l0eT0iLjMiIGZpbGw9Im5vbmUiLz48L2c+PC9zdmc+')] opacity-30 bg-repeat"></div>
        
        {/* Shimmering light effect */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 right-1/4 w-8 h-8 bg-blue-100 rounded-full blur-md animate-pulse"></div>
          <div className="absolute bottom-1/3 left-1/4 w-6 h-6 bg-blue-200 rounded-full blur-md animate-pulse delay-700"></div>
          <div className="absolute top-2/3 right-1/3 w-4 h-4 bg-blue-300 rounded-full blur-md animate-pulse delay-1000"></div>
        </div>
      </div>

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="relative">
              {/* Diamond facet effect */}
              <div className="absolute -inset-6 -z-10 bg-gradient-to-r from-blue-500/20 via-blue-400/10 to-blue-300/20 blur-2xl opacity-70 rounded-2xl"></div>
              
              {/* Crystalline card */}
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden border border-blue-100/50 transform hover:scale-[1.01] transition-all duration-300">
                {/* Diamond-inspired accent at the top */}
                <div className="p-1 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 relative">
                  <div className="absolute inset-0 overflow-hidden">
                    <div className="w-full h-full bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.4),transparent_50%)]"></div>
                  </div>
                </div>
                
                <div className="p-8">
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="bg-gray-50/80 backdrop-blur-sm rounded-lg p-4 border border-gray-100 shadow-sm">
                      <h4 className="font-bold text-lg text-blue-500 mb-1 flex items-center">
                        <span className="mr-2 opacity-80">◆</span>
                        Perinteiset algoritmit
                      </h4>
                      <ul className="space-y-2 text-sm">
                        <li className="flex items-start">
                          <span className="text-red-500 mr-2">✗</span>
                          <span>Staattiset säännöt ja kiinteät kaavat</span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-red-500 mr-2">✗</span>
                          <span>Rajallinen personointikyky</span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-red-500 mr-2">✗</span>
                          <span>Jää jälkeen uusista trendeistä</span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-red-500 mr-2">✗</span>
                          <span>Epäjohdonmukainen tarkkuus</span>
                        </li>
                      </ul>
                    </div>
                    <div className="bg-blue-500/5 backdrop-blur-sm rounded-lg p-4 border border-blue-100/50 shadow-sm">
                      <h4 className="font-bold text-lg text-blue-500 mb-1 flex items-center">
                        <Diamond className="w-4 h-4 mr-2" />
                        OrderSales.AI
                      </h4>
                      <ul className="space-y-2 text-sm">
                        <li className="flex items-start">
                          <span className="text-blue-500 mr-2">✓</span>
                          <span>Jatkuvasti oppiva dynaaminen malli</span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-blue-500 mr-2">✓</span>
                          <span>Parannettu personointikyky</span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-blue-500 mr-2">✓</span>
                          <span>Reaaliaikainen sopeutuminen trendeihin</span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-blue-500 mr-2">✓</span>
                          <span>Parantuva tarkkuus palautesilmukoilla</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-blue-50 to-white backdrop-blur-sm rounded-lg p-4 border border-blue-100/50 shadow-sm">
                    <h4 className="font-bold mb-2 text-center">Keskimääräiset tulokset verkkokaupoille</h4>
                    <div className="grid grid-cols-3 gap-4">
                      <div className="text-center transform hover:scale-105 transition-transform">
                        <div className="text-2xl font-bold text-blue-500 relative">
                          <span className="relative z-10">38%</span>
                          <div className="absolute -inset-1 bg-blue-100/50 blur-sm rounded-full -z-10"></div>
                        </div>
                        <div className="text-xs">Myynnin kasvu</div>
                      </div>
                      <div className="text-center transform hover:scale-105 transition-transform">
                        <div className="text-2xl font-bold text-blue-500 relative">
                          <span className="relative z-10">42%</span>
                          <div className="absolute -inset-1 bg-blue-100/50 blur-sm rounded-full -z-10"></div>
                        </div>
                        <div className="text-xs">Asiakastyytyväisyys</div>
                      </div>
                      <div className="text-center transform hover:scale-105 transition-transform">
                        <div className="text-2xl font-bold text-blue-500 relative">
                          <span className="relative z-10">27%</span>
                          <div className="absolute -inset-1 bg-blue-100/50 blur-sm rounded-full -z-10"></div>
                        </div>
                        <div className="text-xs">Toiminnan tehokkuus</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="order-1 lg:order-2">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Asiakaskäyttäytyminen ja trendit muuttuvat{" "}
              <span className="gradient-text relative">
                Nopeammin kuin koskaan
                <div className="absolute -inset-1 bg-blue-300/10 blur-sm -z-10 rounded-lg"></div>
              </span>
            </h2>
            <p className="text-lg text-appella-darkGray mb-8">
              OrderSales.AI:n tekoälyratkaisut on suunniteltu sopeutumaan ja kehittymään nopeasti muuttuvien 
              asiakasmieltymysten ja markkinatrendien mukana, tarjoten kilpailuetua verkkokaupoille.
            </p>
            
            <div className="space-y-6">
              <BenefitItem title="Dynaaminen oppimismalli">
                Oppii jatkuvasti käyttäjäpalautteesta ja kehittyvistä trendeistä mahdollistaen reaaliaikaiset 
                suositukset, kun taas perinteiset algoritmit nojaavat staattisiin sääntöihin ja kiinteisiin kaavoihin.
              </BenefitItem>
              
              <BenefitItem title="Parannettu personointi">
                Käyttää monenlaista dataa aiemmista ostoista, selaushistoriasta, asiakaskysymyksistä 
                ja kontekstuaalisista tekijöistä ymmärtääkseen yksilöllisten mieltymysten vivahteita.
              </BenefitItem>
              
              <BenefitItem title="Parantunut tarkkuus">
                Jatkuva palaute tarkoittaa parempia ennusteita siitä, mistä asiakkaat pitävät, 
                mikä johtaa parempaan sitoutumiseen ja konversioon verkkokaupallesi.
              </BenefitItem>
              
              <BenefitItem title="Mukautuva älykkyys">
                Trendit ja kuluttajakäyttäytyminen muuttuvat nopeasti. Tekoälymme mukautuu näihin muutoksiin 
                varmistaen suositusten pysyvän relevantteina, kun sääntöpohjaiset algoritmit jäävät jälkeen.
              </BenefitItem>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

interface BenefitItemProps {
  title: string;
  children: React.ReactNode;
}

const BenefitItem = ({ title, children }: BenefitItemProps) => {
  return (
    <div className="flex items-start bg-white/70 backdrop-blur-sm p-4 rounded-lg border border-blue-100/50 shadow-sm hover:shadow-md transition-all hover:translate-x-1 hover:border-blue-200/50 group">
      <div className="relative mr-3 flex-shrink-0">
        <div className="absolute -inset-1 rounded-full bg-blue-300/20 blur-sm group-hover:bg-blue-400/30 transition-all"></div>
        <CheckCircle className="text-blue-500 mt-1 relative z-10" />
      </div>
      <div>
        <h3 className="font-semibold text-lg mb-1 flex items-center">
          {title}
          <span className="ml-2 text-xs text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity">◆</span>
        </h3>
        <p className="text-appella-darkGray">{children}</p>
      </div>
    </div>
  );
};

export default Benefits;
